module.exports = __webpack_public_path__ + "static/media/facebook-icon.3ae13bc8.svg";